import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Mail, Loader2, Check, Send } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function NewsletterSignup({ source = 'footer', variant = 'inline' }) {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email, source });
      setDone(true);
      toast.success("You're in! Watch your inbox for drops & deals.");
    } catch {
      toast.error('Could not subscribe. Try again?');
    } finally {
      setBusy(false);
    }
  };

  const isHero = variant === 'hero';

  if (done) {
    return (
      <div
        className={`flex items-center gap-3 ${isHero ? 'justify-center text-base' : 'text-sm'} text-emerald-400`}
        data-testid="newsletter-success"
      >
        <Check className={isHero ? 'w-6 h-6' : 'w-5 h-5'} />
        <span>You're subscribed. Welcome to the DYSSC inner circle.</span>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      className={`flex gap-2 ${isHero ? 'max-w-md mx-auto' : 'max-w-sm'}`}
      data-testid={`newsletter-form-${source}`}
    >
      <div className="relative flex-1">
        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-500" />
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className={`w-full bg-[#0B0B0C] border border-zinc-800 rounded-lg pl-9 pr-3 ${
            isHero ? 'py-3.5 text-base' : 'py-2.5 text-sm'
          } text-white focus:outline-none focus:border-[#E02128] transition-colors`}
          data-testid="newsletter-email-input"
        />
      </div>
      <button
        type="submit"
        disabled={busy}
        className={`shrink-0 font-semibold bg-[#E02128] hover:bg-[#c41d23] text-white rounded-lg disabled:opacity-50 flex items-center gap-2 transition-colors ${
          isHero ? 'px-6 py-3.5 text-base' : 'px-4 py-2.5 text-sm'
        }`}
        data-testid="newsletter-submit"
      >
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
        Subscribe
      </button>
    </form>
  );
}
